import React from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import './style.css'
import Fitures from 'json/fitures'
import Judul from 'components/componentsmall/title'

export default function main_fitures() {
    return (
        <Container className="home-fiture">
            <Judul judul="Fitur-fitur utama Malmora" />
            <Row>
                <Col md={6}>
                    <img src="asset/home/img-mobile.png" alt="mobile" />
                </Col>
                <Col md={6}>
                    {
                        Fitures.map((data, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="card-body">
                                        <h5 className="card-title">{data.title}</h5>
                                        <p className="card-text">{data.text}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </Col>
            </Row>
        </Container>
    )
}
